import { Button, Drawer, DrawerProps, Space } from "antd";
import EditorBasico from "../Core/EditorBasico";
import { ReactNode, useRef, useState, cloneElement, ReactElement } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { DecoupledEditor } from "ckeditor5";
import React from "react";

interface IEditorDrawerProps extends DrawerProps
{
    onChange?:(conteudo:string|null, editorRef:React.RefObject<CKEditor<DecoupledEditor>>, evento:React.MouseEvent<HTMLElement, MouseEvent>) => void;
    elementoGatilho?:ReactNode;
    value?:string|null
}
export default function EditorDrawer({
    width,
    open,
    destroyOnClose,
    onClose,
    onChange,
    elementoGatilho,
    value,
    ...rest
}:IEditorDrawerProps) {
    width = width ?? "100%";
    value = value ?? null;
    destroyOnClose = destroyOnClose ?? true;
    
    const usandoElementoGatilho = (elementoGatilho ?? null) != null;
    const [ openInterno, setOpenInterno ] = useState(false);
    const refEditor = useRef<CKEditor<DecoupledEditor>>(null);

    function finalizar(evento:React.MouseEvent<HTMLElement, MouseEvent>) {
        const conteudo:string|null = refEditor.current?.editor?.getData() ?? null;
        onChange?.(conteudo, refEditor, evento);
        fechar(evento);
    }

    function fechar (evento:React.MouseEvent<HTMLElement, MouseEvent>|React.MouseEvent<Element, MouseEvent>|React.KeyboardEvent<Element>) {
        if (usandoElementoGatilho) setOpenInterno(false);
        onClose?.(evento);
    }

    return <React.Fragment>
        {usandoElementoGatilho && cloneElement(elementoGatilho as React.ReactElement<any>, { onClick : () => {
            setOpenInterno(true);
        } })}
        <Drawer
            className="editor-drawer"
            width={width}
            open={usandoElementoGatilho ? openInterno : open}
            onClose={fechar}
            extra={<Space>
                <Button type="primary" danger onClick={fechar}>Cancelar</Button>
                <Button type="primary" onClick={finalizar}>
                    Finalizar edição
                </Button>
            </Space>}
            destroyOnClose={destroyOnClose}
            {...rest}
        >
            <EditorBasico
                ref={refEditor}
                data={value}
            />
        </Drawer>
    </React.Fragment>
}